import { render } from "./CookieConsentBanner.vue?vue&type=template&id=42fdcd52"
import script from "./CookieConsentBanner.vue?vue&type=script&lang=js"
export * from "./CookieConsentBanner.vue?vue&type=script&lang=js"

import "./CookieConsentBanner.vue?vue&type=style&index=0&id=42fdcd52&lang=css"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__